import { Box, Button, Grid, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

// Main BackupCodes styles
export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(5),
}));

export const ModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 512,
  boxShadow: '24',
  borderRadius: 8,
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(5),
}));

export const ButtonsGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(4.5),
}));

export const GenerateButtonContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3.5),
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),

  [theme.breakpoints.up('md')]: {
    margin: `${theme.spacing(1)} 0`,
  },
}));

export const DownloadButton = styled(ActionButton)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    marginLeft: theme.spacing(2),
  },
}));

export const WhiteButton = styled(Button)(({ theme }) => ({
  background: theme.palette.common.white,
  color: alpha(theme.palette.common.black, 0.75),

  '&:hover, &:active, &:focus': {
    backgroundColor: theme.palette.grey[200],
    boxShadow: 'none',
  },
}));

interface GenerateButtonProps {
  isMd?: boolean;
}

export const GenerateButton = styled(WhiteButton, {
  shouldForwardProp: prop => prop !== 'isMd',
})<GenerateButtonProps>(({ theme, isMd }) => ({
  border: `2px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  padding: isMd ? `${theme.spacing(0.75)} ${theme.spacing(2)}` : `${theme.spacing(1)} ${theme.spacing(2.5)}`,

  '&:hover, &:active, &:focus': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    boxShadow: 'none',
  },

  '&:disabled': {
    borderColor: alpha(theme.palette.common.black, 0.26),
  },
}));

// BackupCodesInfo styles
export const ItemsContainer = styled(Grid)(({ theme }) => ({
  borderRadius: 4,
  border: `1px solid ${theme.palette.primary.main}`,
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  marginTop: theme.spacing(5),

  [theme.breakpoints.up('lg')]: {
    marginTop: 0,
  },
}));

export const Item = styled(Grid)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(2),

  [theme.breakpoints.up('md')]: {
    maxWidth: `${100 / 5}%`,
    flexBasis: `${100 / 5}%`,
  },
}));

export const ItemCode = styled(Typography)(({ theme }) => ({
  color: alpha(theme.palette.common.black, 0.6),
  fontWeight: 600,
  fontSize: '1.125rem',
}));

export const NoBackupCodesText = styled(Typography)(({ theme }) => ({
  padding: `${theme.spacing(3)} 0`,
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

// Modal specific styles
export const ModalContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 512,
  boxShadow: '24',
  borderRadius: 8,
}));

export const BoxContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(5),
}));

export const PrintLogo = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(4),
  width: '25%',
}));

export const Logo = styled('img')({
  maxWidth: '100%',
  height: 'auto',
});

export const ModalTitle = styled(Typography)(({ theme }) => ({
  paddingBottom: theme.spacing(1.5),
}));

export const ModalSubtitle = styled(Typography)({
  margin: '1rem 0',
});

export const ModalSubtitleGrey = styled(Typography)(({ theme }) => ({
  color: alpha(theme.palette.common.black, 0.7),
}));

// PrintableBackupCodes styles
export const PrintableContainer = styled(Grid)({
  display: 'flex',
});

export const StyledPrintGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(5),
}));

export const HiddenGrid = styled(Grid)({
  display: 'none',
});

export const CenterContainer = styled(Grid)({
  alignItems: 'center',
});

export const GridItem = styled(Grid)(({ theme }) => ({
  '&.modal': {
    paddingRight: 0,
  },
  '&.regular': {
    paddingRight: theme.spacing(2),
  },
}));
